<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>
                Assign Tag To Account Data
                {{ campaignName != null ? campaignName : "" }}
              </h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>

          <div class="vx-row">
            <div class="m-5">
              <h6>Choose Tag :</h6>
            </div>

            <ul class="vertical-align">
              <li v-for="v in all_account_tags" class="p-1">
                <vs-checkbox v-model="selected_tag" :vs-value="v.id">{{
                  v.tag
                }}</vs-checkbox>
              </li>
            </ul>

            <vs-button @click.prevent="updateTagToSDAccount">Submit</vs-button>
          </div>
          <div class="centerx">
            <span class="text-danger text-sm">{{ please_choose_tag }}</span>
          </div>

          <div v-if="showDatagrid">
            <ClientDataGrid
              :key="companySDAccountComponentKey"
              @sendSelectionToActualPage="sendSelectionToActualPage"
              ref="SDQCAccountClientSide"
              :columnDefs="accountColumnDefs"
              :rowData="accountRecords"
              :rowSelection="'multiple'"
            >
            </ClientDataGrid>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import DataGrid from "@/components/aggrid/Aggrid.vue";
import ClientDataGrid from "@/components/aggrid/AggridClient.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
import _ from "lodash";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import moduleTagManagement from "@/store/tag-management/moduleTagManagement.js";
import moment from 'moment'
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
      authorized:true,
      please_choose_tag: null,
      all_account_tags: [],
      campaignDescription: [],
      companySDAccountComponentKey: 0,
      showSalesDeveloperSubmit: false,
      showCampaignSelection: true,
      showDatagrid: false,
      please_choose_options: null,
      chooseExistingList: false,
      accountColumnDefs: [],
      selected_campaign: null,
      accountDataSource: [],
      accountRecords: [],
      campaignId: null,
      campaignName: null,
      selected_table_ids: [],
      selected_sales_developer_id: null,
      selected_tag: []
    };
  },
  components: {
    "v-select": vSelect,
    DataGrid,
    AccountAutocomplete,
    CampaignAutocomplete,
    ClientDataGrid,
    moduleTagManagement
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }

    if (!moduleTagManagement.isRegistered) {
      this.$store.registerModule("TagsManagement", moduleTagManagement);
      moduleTagManagement.isRegistered = true;
    }

    // this.checkSalesDeveloperCampaignPermission()

  },
  mounted() {
    if(this.authorized){
      this.fetchCampaign();
    this.fetchAllTagsWithSalesDeveloperId();
    }

   
  },
  watch: {},
  methods: {
    checkSalesDeveloperCampaignPermission() {
      let data = {}
      data.campaign_id = this.$route.params.campaignId;
      data.user_id = this.user_id;
      this.$store
        .dispatch("campaignsManagement/checkSalesDeveloperCampaignPermission" , data)
        .then(res => {
          let result = res.data
          if (!result){
            this.authorized = false
            this.$router.replace("/unauthorized")
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    fetchAllTagsWithSalesDeveloperId() {
      this.$store
        .dispatch(
          "TagsManagement/fetchAllTagsWithSalesDeveloperId",
          this.$route.params.sd_user_id
        )
        .then(res => {
          let result = res.data;
          result = result.filter(ele => ele.type == "account");
          this.all_account_tags = result;
          console.log(this.all_account_tags);
        })
        .catch(err => {
          console.error(err);
        });
    },
    sendSelectionToActualPage(items) {
      let selected_table_ids = [];
      items.forEach(element => {
        selected_table_ids.push(element.id);
      });

      this.selected_table_ids = selected_table_ids;
      this.showSalesDeveloperSubmit = true;
    },
    updateTagToSDAccount() {
      let self = this;
      let data = {};
      data.table_ids = self.selected_table_ids;
      data.selected_account_tag_ids = self.selected_tag;
      data.campaign_id = self.campaignId;
      data.campaign_name = self.campaignName;
      data.sales_developer_id = self.user_id;
      data.level = "account";

      if (data.selected_account_tag_ids.length == 0) {
        self.please_choose_tag = "Please select tag to update";
      }

      self.$store
        .dispatch("campaignsManagement/updateTagToSDAccount", data)
        .then(res => {
          if (res) {
            if (res.data.status == "success") {

              self.please_choose_tag = null

              self.selected_table_ids = [];
              self.selected_tag = [];
              self.$refs.SDQCAccountClientSide.gridApi.deselectAll();
              self.$refs.SDQCAccountClientSide.gridApi.refreshCells({
                force: true
              });
              self.getAccountDataSource();
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    fetchCampaign() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
          this.campaignId = this.campaignDescription.id;
          this.campaignName = this.campaignDescription.campaign_name;
          this.getSDAccountColumns();
          this.getAccountDataSource();
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    getAccountDataSource() {
      var self = this;
      self.$vs.loading()
      let data = {};
      data.campaign_id = self.campaignId;
      // data.sales_developer_id = self.$route.params.sd_user_id
      self.$store
        .dispatch("accountsManagement/fetchAllSDQCAccountsForClientSide", data)
        .then(function(response) {
          let response_data = JSON.parse(response.data);


          response_data.forEach(function (ele) {



if (ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0) {
  if (ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0.length == 0) {
    ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0 = "";
  } else if (ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0.length > 1) {
    ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0 = "ΞΞ";
  } else {
    ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0 = ele._c2c0a5f8_e0aa_4ea9_b0e9_92195a9245a0[0].url;
  }
}

if (ele._c68046a9_7aaf_4876_9c49_936c28d479af) {

  if (ele._c68046a9_7aaf_4876_9c49_936c28d479af.length == 0) {
    ele._c68046a9_7aaf_4876_9c49_936c28d479af = "";
  } else if (ele._c68046a9_7aaf_4876_9c49_936c28d479af.length > 1) {
    ele._c68046a9_7aaf_4876_9c49_936c28d479af = "ΞΞ";
  } else {
    ele._c68046a9_7aaf_4876_9c49_936c28d479af = ele._c68046a9_7aaf_4876_9c49_936c28d479af[0].url;
  }
}

if (ele._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a) {

  if (ele._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a.length == 0) {
    ele._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a = "";
  } else if (ele._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a.length > 1) {
    ele._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a = "ΞΞ";
  } else {
    ele._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a = ele._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a[0].phone_code + ele._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a[0].phone_no;
  }
}




});
         

          self.accountRecords = response_data;
          self.showDatagrid = true;
          self.$vs.loading.close()
        })
        .catch(err => {
          console.error(err);
        });
    },
    getSDAccountColumns () {
  let self = this
  self.$store
    .dispatch(
      'campaignsManagement/getAllAccountSelectedCampaignColumns',
      self.$route.params.campaignId
    )
    .then(res => {

      let selected_columns = JSON.parse(res.data);



selected_columns = selected_columns.filter(function(ele) {
  return ele.identifier != 'phone_code' && ele.identifier != 'phone_type' && ele.identifier != 'switchboard_phone_code' && ele.identifier != 'phone' && ele.identifier != 'switchboard' && ele.identifier != 'account_status' && ele.identifier != 'account_status_notes'
});


var index = 1;
selected_columns.forEach(function(ele) {
ele.id = ele.uuid

ele.headerName = ele.name;

ele.field = '_' + ele.id.replaceAll("-", "_");
if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }

                if (ele.type == "date" || ele.type == "datetime") {
  ele.filter = "agDateColumnFilter";
} else if (ele.type == "number") {
  ele.filter = "agNumberColumnFilter";
} else {
  ele.filter = "agTextColumnFilter";
}



ele.width = 170;
ele.filterParams = {
buttons: ["apply", "reset"],
maxNumConditions: 4
};
});

this.accountColumnDefs = selected_columns

let actions = {
  headerCheckboxSelection: true,
  headerCheckboxSelectionFilteredOnly: true,
  headerName: "Actions",
  field: "transactions",
  cellRenderer: "CellRendererActions",
  suppressHeaderMenuButton: true,
  checkboxSelection: true,

  pinned: true,
  width: 50
};

      this.accountColumnDefs.push(actions)

    
      let tag = {
        column_name: "tag",
        field: "tag",
        filter: "agSetColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        },
        headerName: "Tag"
      };

      this.accountColumnDefs.push(tag);

      let account_status = {
        column_name: "account_status",
        field: "account_status",
        filter: "agSetColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        },
        headerName: "Account Status"
      };

      this.accountColumnDefs.push(account_status);

      let account_status_notes = {
        column_name: "account_status_notes",
        field: "account_status_notes",
        filter: "agSetColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        },
        headerName: "Account Status Notes"
      };

      this.accountColumnDefs.push(account_status_notes);


    })
    .catch(err => {
      console.log(err)
    })
},
   
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
.vertical-align {
  display: flex;
  justify-content: center; /* align horizontal */
  align-items: center; /* align vertical */
  /* width: 800px; */
}
</style>
